<template lang="pug">
#CambiarEnvio
  b-button(variant="action" @click="openModal")
    | Cambiar a Envío
  
  b-modal.hide-footer(v-model="showModal" title="Agregar costo de envío" no-close-on-backdrop size="md")
    p Se rechazará la OV actual y se creará una nueva con el costo de envío indicado.
      br
      | La OT continuará en "Reparado por pagar".
    
    b-form-group(label="Costo de envío ($)")
      b-form-input(
        v-model.number="costoEnvio"
        type="number"
        min="1"
        placeholder="Ej: 4990"
      )
    small.text-danger(v-if="submitted && (!costoEnvio || costoEnvio <= 0)") El monto de envío es requerido y debe ser mayor a 0.
    
    template(#modal-footer="{ cancel }")
      b-button(size="sm" variant="secondary" @click="cancel" :disabled="loading") Cancelar
      b-button(size="sm" variant="primary" @click="confirmar" :disabled="loading || !costoEnvio || costoEnvio <= 0")
        b-spinner(v-if="loading" small)
        span(v-else) Confirmar

</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'CambiarEnvio',
  props: {
    dataOv: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      loading: false,
      costoEnvio: null,
      submitted: false,
    }
  },
  methods: {
    ...mapActions('OVStore', ['cambiarEnvio']),
    async confirmar() {
      this.submitted = true
      if (!this.costoEnvio || this.costoEnvio <= 0) return

      this.loading = true
      try {
        const res = await this.cambiarEnvio({
          id_oportunidad_venta: this.dataOv.id,
          costo_envio: this.costoEnvio,
        })
        this.$bvToast.toast('OV recreada con envío agregado.', {
          variant: 'success',
          title: 'Cambio a Envío',
          autoHideDelay: 5000,
        })
        const newId = res?.data?.id
        if (newId) {
          this.hideModal()
          this.$router.push({ path: `/oportunidad-venta/${newId}` })
          return
        }
      } catch (error) {
        this.$bvToast.toast('Error al cambiar a envío.', {
          variant: 'danger',
          title: 'Error',
          autoHideDelay: 5000,
        })
      } finally {
        this.loading = false
        this.$emit('reloadAll')
        this.hideModal()
      }
    },
    openModal() {
      this.showModal = true
      this.costoEnvio = null
      this.submitted = false
    },
    hideModal() {
      this.showModal = false
    },
  },
}
</script>
<style lang="scss" scoped></style>
